import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent, { fillColor } from "./Styled";
/**
 * moaui Styled GuideBox
 *
 * @param props - children, tag, show, width, height, fill, column, row, rowReverse, columnReverse, spacing, center, horLeft, horCenter, horRight, horSpaceBetween, verTop, verCenter, verBottom, verSpaceBetween, duration, pulse, loading, overflow, borderRadius, border, flexGrow, onKeyDown
 * @example
 * <GuideBox id="" show={true} width={100} height={100} fill='1' />
 * @returns React.ReactElement
 */
var GuideBox = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
GuideBox.defaultProps = {
    id: '',
    show: false,
    width: 'auto',
    height: 'auto',
    fill: '1',
    opacity: 1,
    duration: 1,
};
var SampleProps = {};
export default GuideBox;
export { SampleProps as GuideBoxSample, fillColor as GuideBoxFillColor, };
